import axiosInstance from "../config/axiosInterceptor";

export async function getNode() {
  return await axiosInstance.get("/api/Node");
}

export async function getNodeWithStatus() {
  return await axiosInstance.get("/api/Node/NodeWithStatus");
}

export async function getOnlineNodes() {
  return await axiosInstance.get("/api/Node/OnlineNodes");
}

export async function getNodeById(id) {
  return await axiosInstance.get(`/api/Node/${id}`);
}

export async function getNodeByRegionId(regionId) {
  return await axiosInstance.get(`/api/Node/ByRegionId/${regionId}`);
}

export async function isNodeOnline(nodeId) {
  return await axiosInstance.get(`/api/Node/IsNodeOnline/${nodeId}`);
}

export async function createNode(nodeData) {
  return await axiosInstance.post("/api/Node", nodeData);
}

export async function updateNode(nodeData) {
  return await axiosInstance.put("/api/Node", nodeData);
}

export async function deleteNode(id) {
  return await axiosInstance.delete(`/api/Node/${id}`);
}